import React, { useEffect, useState, useMemo } from "react";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import DeleteProfilePictureModal from "./Modals/DeleteProfilePictureModal.js";
import UploadProfilePictureModal from "./UploadProfilePictureModal.js";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../../../contexts/mailContext/mailContext.js";
import config from "config.ts";

const avatarImage =
  `${config.api.resource}/assets/images/avatar_default_large.png`;

const ProfilePicture = ({ userData, selectedFileId }) => {
  const { setModal } = useModal();
  const { getTextByKey } = useContent();
  const { getUserProfileImage, isUserHasProfileImage } = useUser();
  const { getFilesData, getFilesList } = useMail();
  const [image, setImage] = useState(
    selectedFileId ? getFilesData()[selectedFileId].PreviewSrc : null
  );
  const [isHaveBrandingProfile, setIsHaveBrandingProfile] = useState(false);
  useEffect(() => {
    getBrandingProfilePicture();
  }, []);

  //get profile image and if empty set default profile
  const getProfileImage = () => {
    if (isUserHasProfileImage) {
      if (userData.ProfileImageUrl) {
        return getUserProfileImage();
      }
      return avatarImage;
    } else {
      return avatarImage;
    }
  };

  // get the list of images within current email
  const mailImagesList = useMemo(
    () =>
      getFilesList().filter(
        (fileId) => getFilesData()[fileId]?.Type === "Image"
      ),
    [getFilesList()]
  );

  // set first image from the list as profile
  useEffect(() => {
    mailImagesList.length > 0 && !image && !getUserProfileImage()
      ? setImage(getFilesData()[mailImagesList[0]].PreviewSrc)
      : (() => {})();
  }, [mailImagesList]);

  //get brand profile picture to check if exist (for merge profiles button)
  const getBrandingProfilePicture = async () => {
    const response = await apiRequest(
      "Users",
      "ReactGetUserBrandingProfilePicture"
    );
    if (response.status === "success") {
      if (response.data === "emptyBrandProfile") {
        setIsHaveBrandingProfile(false);
      } else {
        setIsHaveBrandingProfile(true);
      }
    }
  };

  return (
    <div className="top-section">
      <div className="profile-picture-container">
        <div
          className="upload-profile"
          style={{
            backgroundImage: `url(${getProfileImage()})`,
          }}
        >
          <div className="profileHeight">
            <div
              className="profile-remove-div"
              onClick={() => {
                setModal(() => <DeleteProfilePictureModal />);
              }}
            >
              <Tooltip
                id={"delete-picture"}
                tooltipTextKey={
                  "profileuserdetails-remove-profile-picture-tooltip"
                }
                //hardPositioned
              >
                <Icon
                  name="trash-solid-b"
                  gray
                  className="profil-remove-icon"
                />
              </Tooltip>
            </div>
          </div>
          <div className="upload-profile-img-div">
            <div className="profile-img-icon">
              <i className="fa fa-camera camProfileIcon"></i>
            </div>
            <div
              className="profile-img-text"
              onClick={() => setModal(() => <UploadProfilePictureModal />)}
            >
              {getTextByKey("profileuserdetails-upload-new-profile-btn")}
            </div>
          </div>
        </div>
        <div className="profileResult_ltr"></div>{" "}
        <div className="loaderProfile_ltr">
          <Image
            className={`user-avatar-image ${
              !isUserHasProfileImage() ? " default-avatar" : ""
            }`}
            src={getProfileImage()}
            title=""
            alt=""
          />
        </div>
      </div>
      {!isHaveBrandingProfile && isUserHasProfileImage() ? (
        <div className="merge-profile-images">
          <LinkToNewTab
            isNewTab
            page="user/branding/cover-logo?set_profile=true"
          >
            <Tooltip
              id={"merge-pictures"}
              tooltipTextKey={
                "profileuserdetails-image-as-business-logo-tooltip"
              }
              //hardPositioned
            >
              {getTextByKey("profileuserdetails-image-as-business-logo-link")}
            </Tooltip>
          </LinkToNewTab>
        </div>
      ) : null}
    </div>
  );
};

export default ProfilePicture;
